import { useTranslation } from "react-i18next";

import productionStatuses from "astrid-firestore/src/api/productions/constants/productionStatuses";
import productionTypes from "astrid-firestore/src/api/productions/constants/productionTypes";

export default function useProductionStatusLadderSteps({ production }) {
	const { t } = useTranslation();

	return [
		{
			text: t("offer", "Offer"),
			active: production.status === productionStatuses.OFFER,
		},
		{
			text: t("planning", "Planning"),
			active: production.status === productionStatuses.PLANNING,
		},
		{
			text: t("accepted", "Accepted"),
			active: production.status === productionStatuses.ACCEPTED,
		},
		{
			text: t("booked", "Booked"),
			active:
				production.status === productionStatuses.PRODUCTION &&
				!production.stats &&
				!production.proofParts &&
				!production.progress,
			hidden: production.productionType === productionTypes.SUBCONTRACT,
			disabled: true,
		},
		{
			text: t("producing", "Producing"),
			active:
				production.status === productionStatuses.PRODUCTION &&
				(production.productionType === productionTypes.SUBCONTRACT ||
					(!!(production.stats || production.proofParts || production.progress) && !production.polishDone)),
		},

		{
			text: t("mastering", "Mastering"),
			active:
				production.status === "production" &&
				!!(production.stats || production.proofParts) &&
				production.polishDone,
			hidden: production.productionType === productionTypes.SUBCONTRACT,
		},
		{
			text: t("completed", "Completed"),
			active: production.status === productionStatuses.DONE,
		},
	];
}
